import Icon from '@components/CustomIcon';
import { FC, Fragment } from 'react';
import type { IntroItem } from './domain';
import * as styles from './Intro.css';

interface Props {
  items: IntroItem[];
}

const Intro: FC<Props> = ({ items }) => (
  <div className={styles.block}>
    {items.map(({ icon, text }) => (
      <div className={styles.item} key={icon}>
        <Icon name={icon} size='lg' />
        <p>
          {text.map((segment, index) =>
            typeof segment === 'string' ? (
              <Fragment key={index}>{segment}</Fragment>
            ) : (
              <span key={index}>{segment.strong}</span>
            ),
          )}
        </p>
      </div>
    ))}
  </div>
);

export default Intro;
